import React, { useEffect } from 'react';
import InternalBanner from './InternalBanner';
/*   import Timeline from './Timeline';  */ 
export default function About() {

    useEffect(() => {
        document.documentElement.style.overflowX = 'hidden';
        return () => {
          document.documentElement.style.overflowX = '';
        };
      }, []);


      


    return (
        <>
            <InternalBanner title="About Us" />
            <section id="nutrition" className="about-company">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="about-content">
                                <p className='mb-4'>Rashtriya e-Pustakalaya is an innovative project launched by the Department of
                                    School Education and Literacy, under the Ministry of Education. It functions as a free
                                    digital library and serves as a national repository of knowledge and stories, tailored
                                    specifically for the young minds of India.
                                </p>
                                <p className='mb-4'>The objective of this digital platform is to cultivate a reading culture and to foster a
                                    sense of pride and curiosity in the youth about their heritage and accomplishments. It
                                    also aims to be a central resource of knowledge for the upcoming generations.
                                </p>
                                <p className='mb-4'>Rashtriya e-Pustakalaya offers a wide range of quality books that are accessible
                                    regardless of location, language, genre, or level, and can be accessed on various
                                    devices. The library is organized into four age-specific categories: 3-8, 8-11, 11-14,
                                    and 14+ years, featuring a diverse collection of non-academic books such as fiction,
                                    non-fiction, biographies, poetry, classics, comics, and novels. The selection
                                    emphasizes Indian history, culture, scientific progress, and other important aspects
                                    of the nation's identity.
                                </p>

                                <p className='mb-4'>
                                    The Rashtriya e-Pustakalaya application will be available for Web, Android and iOS
                                    users. It will include a array of genres like adventure, mystery, humour, literature,
                                    fiction, classics, non-fiction, self-help, history, biographies, comics, picture books,
                                    science, and poetry. The content is curated to promote cultural awareness, national
                                    pride, and empathy, in line with the concept of 'Vasudhaiva Kutumbakam' or 'The
                                    World is One Family'.
                                </p>

                                <p>
                                    As a unique digital library, Rashtriya e-Pustakalya is dedicated to nurture a lifelong
                                    passion for reading in the children and adolescents of India. It provides access to
                                    over 2,200 non-academic titles from more than 40 esteemed publishers, available in
                                    over 22 languages, including English. The initiative supports the National Education
                                    Policy (NEP) 2020 by categorizing books for readers in the age groups of 3-8, 8-11,
                                    11-14, and 14-18 years, ensuring that quality literature is available to all,
                                    transcending barriers of geography, language, and accessibility.
                                </p>
                                {/* <Timeline /> */}


                            </div>

                        </div>
                    </div>
                </div>


            </section>
        </>

    )
}
